import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { ContactModel } from "../../models/contactModel"
import { RFQDeliveryStatus } from "../../constants/rfqDeliveryStatus"
import { TaskInterestStatus } from "../../core/constants/taskInterestStatus"

@Serializable
export class SupplierListView {
  uid: string = ""
  name: string = ""
  deliveredStatus: RFQDeliveryStatus = RFQDeliveryStatus.NotDelivered
  contacts: ContactModel[] = []
  isSelectedInAgreement: boolean = false
  interestStatus: TaskInterestStatus = TaskInterestStatus.Unanswered

  constructor(data: Partial<SupplierListView> | null = null) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
